/**
 * Copyright (c) 2023 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { VideoProviderName } from '../contexts/videoProvider/types';

const getApiKeyName = (roomId: string, providerPrefix?: string): string => {
  return `ron-${roomId}-${providerPrefix ?? 'twilio'}APIKey`;
};

export const getVideoVendorApiKey = (roomId: string, providerPrefix?: string): string | null => {
  return sessionStorage.getItem(getApiKeyName(roomId, providerPrefix));
};

export const setVideoVendorApiKey = (roomId: string, apiKey: string, providerPrefix?: string): void => {
  sessionStorage.setItem(getApiKeyName(roomId, providerPrefix), apiKey);
};

export const removeVideoVendorApiKey = (roomId: string): void => {
  sessionStorage.removeItem(getApiKeyName(roomId, VideoProviderName.TWILIO));
  sessionStorage.removeItem(getApiKeyName(roomId, VideoProviderName.ZOOM));
};
